module.exports = {"body":"<img class=\"style.sidebar_image\" src=\"/images/projekte/lankenau01.jpg\" />\n<img class=\"style.sidebar_image\" src=\"/images/projekte/lankenau02.jpg\" />\n<img class=\"style.sidebar_image\" src=\"/images/projekte/lankenau03.jpg\" />\n<img class=\"style.sidebar_image\" src=\"/images/projekte/lankenau04.jpg\" />\n<img class=\"style.sidebar_image\" src=\"/images/projekte/lankenau05.jpg\" />\n<img class=\"style.sidebar_image\" src=\"/images/projekte/lankenau06.jpg\" />"}


//////////////////
// WEBPACK FOOTER
// ./projekte/lankenau.sidebar.md
// module id = 1014
// module chunks = 0